export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑面料',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ fabricOwner }) => ['ecomAmazon'].includes(fabricOwner),
  },
  {
    text: that.$l('menu_text_copy') || '复制面料',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'M',
    disabled: ({ fabricOwner }) => ['ecomAmazon'].includes(fabricOwner),
  },
  {
    text: that.$l('menu_text_delete') || '删除面料',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ fabricStatus, fabricOwner }) => !['Y'].includes(fabricStatus) || ['ecomAmazon'].includes(fabricOwner),
  },
  {
    text: that.$l('menu_text_recovery') || '恢复面料',
    icon: 'el-icon-refresh-left',
    menuType: 'recovery',
    allow: 'D',
    disabled: ({ fabricStatus, fabricOwner }) => !['N'].includes(fabricStatus) || ['ecomAmazon'].includes(fabricOwner),
  },
  {
    text: that.$l('menu_text_printer') || '打印面料',
    icon: 'el-icon-printer',
    menuType: 'printer',
    divided: true,
    allow: 'P',
  },
]
